import React from "react";
import insaLogo from "assets/images/insaLogo.svg";
import { useNavigate } from "react-router-dom";
import { AiOutlineMail } from "react-icons/ai";
import { MdOutlineCall } from "react-icons/md";
const Navbar = () => {
  const navigate = useNavigate();
  const navigationHandler = () => {
    if (sessionStorage.getItem("userToken")) navigate("/kyp/policies");
    else navigate("/");
  };
  const nav_style = "flex justify-center items-center gap-1";
  const nav_icon = "w-6 font-bold h-6";
  return (
    <nav className="py-2 z-50 fixed top-0 w-screen flex justify-between shadow-lg md:shadow-xl h-[3.7rem] px-5 md:px-10 md:h-[4.5rem] bg-white items-center">
      <img src={insaLogo} alt="insa-logo" className="w-36 h-9 md:w-52 cursor-pointer" onClick={navigationHandler} />
      <div className="flex gap-5 md:gap-10">
        <a href="mailto:corporate@insurancesamadhan.com" className={nav_style}>
          <AiOutlineMail className={nav_icon} />
          <p className="hidden md:block">corporate@insurancesamadhan.com</p>
        </a>
        <a href="tel:9513631312" className={nav_style}>
          <MdOutlineCall className={nav_icon} /> <p className="hidden md:block">95136-31312</p>
        </a>
        <a href="https://api.whatsapp.com/send?phone=+919910998252&amp;text=Hi" className={nav_style}>
          <img src={require("../../assets/images/wtspImg.png")} className={nav_icon} />
          <p className="hidden md:block">99109-98252</p>
        </a>
      </div>
    </nav>
  );
};

export default Navbar;
